/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1EmployeepostEmployeepostidClassStudents202,
  PostApiV1EmployeepostEmployeepostidClassStudents400,
  PostApiV1EmployeepostEmployeepostidClassStudents401,
  PostApiV1EmployeepostEmployeepostidClassStudents404,
  PostApiV1EmployeepostEmployeepostidClassStudents409,
  PostApiV1EmployeepostEmployeepostidClassStudents500,
  PostApiV1EmployeepostEmployeepostidClassStudentsMutationRequest,
  PostApiV1EmployeepostEmployeepostidClassStudentsMutationResponse,
  PostApiV1EmployeepostEmployeepostidClassStudentsPathParams,
} from "../../types/employeePostController/PostApiV1EmployeepostEmployeepostidClassStudents.ts";
import { createEmployeePostClassStudentRequestViewModelSchema } from "../createEmployeePostClassStudentRequestViewModelSchema.ts";
import { employeePostClassStudentViewModelSchema } from "../employeePostClassStudentViewModelSchema.ts";

export const postApiV1EmployeepostEmployeepostidClassStudentsPathParamsSchema =
  z.object({
    employeePostId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1EmployeepostEmployeepostidClassStudentsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1EmployeepostEmployeepostidClassStudents202Schema = z.lazy(
  () => employeePostClassStudentViewModelSchema,
) as unknown as ToZod<PostApiV1EmployeepostEmployeepostidClassStudents202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1EmployeepostEmployeepostidClassStudents400Schema =
  z.any() as unknown as ToZod<PostApiV1EmployeepostEmployeepostidClassStudents400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1EmployeepostEmployeepostidClassStudents401Schema =
  z.any() as unknown as ToZod<PostApiV1EmployeepostEmployeepostidClassStudents401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1EmployeepostEmployeepostidClassStudents404Schema =
  z.any() as unknown as ToZod<PostApiV1EmployeepostEmployeepostidClassStudents404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const postApiV1EmployeepostEmployeepostidClassStudents409Schema =
  z.any() as unknown as ToZod<PostApiV1EmployeepostEmployeepostidClassStudents409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1EmployeepostEmployeepostidClassStudents500Schema =
  z.any() as unknown as ToZod<PostApiV1EmployeepostEmployeepostidClassStudents500>;

export const postApiV1EmployeepostEmployeepostidClassStudentsMutationRequestSchema =
  z.lazy(
    () => createEmployeePostClassStudentRequestViewModelSchema,
  ) as unknown as ToZod<PostApiV1EmployeepostEmployeepostidClassStudentsMutationRequest>;

export const postApiV1EmployeepostEmployeepostidClassStudentsMutationResponseSchema =
  z.lazy(
    () => postApiV1EmployeepostEmployeepostidClassStudents202Schema,
  ) as unknown as ToZod<PostApiV1EmployeepostEmployeepostidClassStudentsMutationResponse>;
